import React from 'react';
import { SectionCard } from '../../components/sections/SectionCard';
import { PanelTable } from '../../components/display/PanelTable';
import type { PanelTableColumn } from '../../components/display/PanelTable/types';
import { PENDING_INVOICE_ITEMS_DATA, type PendingInvoiceItemData } from '@shared/data';

interface PendingInvoiceItemsSectionProps {
  isDetailView?: boolean;
  className?: string;
}

const renderAmount = (value: unknown) => {
  const amount = typeof value === 'string' ? value : '$0.00';
  return (
    <span className="font-medium">
      {amount}
    </span>
  );
};

const renderQty = (value: unknown) => {
  const qty = typeof value === 'number' ? value : 0;
  return (
    <span className="text-center">
      {qty}
    </span>
  );
};

export const PendingInvoiceItemsSection = React.memo<PendingInvoiceItemsSectionProps>(({ isDetailView = false, className }) => {
  const columns: PanelTableColumn<PendingInvoiceItemData>[] = [
    {
      key: 'description',
      label: 'DESCRIPTION',
      headerClassName: 'w-[180px]',
      cellClassName: 'font-medium'
    },
    {
      key: 'amount',
      label: 'AMOUNT',
      headerClassName: 'w-[100px]',
      render: renderAmount
    },
    {
      key: 'qty',
      label: 'QTY',
      headerClassName: 'w-[70px]',
      render: renderQty,
      cellClassName: 'text-center'
    },
    {
      key: 'customer',
      label: 'CUSTOMER',
      headerClassName: 'w-[130px]'
    },
    {
      key: 'scheduled',
      label: 'SCHEDULED',
      headerClassName: 'w-[110px]',
      cellClassName: 'whitespace-nowrap text-muted-foreground'
    }
  ];

  const rowActions = (item: PendingInvoiceItemData) => [
    {
      key: 'view-details',
      label: 'View details',
      onClick: () => console.log('View details', item)
    },
    {
      key: 'edit-item',
      label: 'Edit item',
      onClick: () => console.log('Edit item', item)
    },
    {
      key: 'remove-item',
      label: 'Remove item',
      onClick: () => console.log('Remove item', item)
    },
    {
      key: 'invoice-now',
      label: 'Invoice now',
      onClick: () => console.log('Invoice now', item)
    },
    {
      key: 'duplicate',
      label: 'Duplicate',
      onClick: () => console.log('Duplicate', item)
    },
    {
      key: 'export',
      label: 'Export',
      onClick: () => console.log('Export', item)
    }
  ];

  return (
    <SectionCard title="Pending invoice items" layout="down" className={className}>
      <PanelTable
        data={PENDING_INVOICE_ITEMS_DATA}
        columns={columns}
        variant={isDetailView ? 'full' : 'panel'}
        emptyMessage="No pending invoice items found"
        pageSize={5}
        rowActions={rowActions}
      />
    </SectionCard>
  );
});

PendingInvoiceItemsSection.displayName = 'PendingInvoiceItemsSection';